export default "/images/PDQ.jpg?a90bf139d6d3b5449aeeae9a5b9552f3";